import { Component, OnInit } from '@angular/core';
import {Experiencia} from '../../models/experiencia';
import { DgService } from '../../service/dg.service';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.css']
})
export class DetalleComponent implements OnInit {
  dg: Experiencia;
  constructor(private disenografico: DgService) {
    this.dg = disenografico.disenoGrafico;
   }

  ngOnInit() {
    // ocultar grafica Photoshop
    const valorGrafica = this.disenografico.disenoGrafico.porcentajePhotoshop;
    if (valorGrafica === '0' || valorGrafica === '') {

      document.querySelector('#Photoshop').parentElement.parentElement.style.display = 'none';
    }
     // ocultar grafica Illustrator
    const valorIllustrator = this.disenografico.disenoGrafico.porcentajeIllustrator;
    if (valorIllustrator === '0' || valorIllustrator === '') {

      document.querySelector('#Illustrator').parentElement.parentElement.style.display = 'none';
    }
     // ocultar grafica InDesign
    const valorIndesign = this.disenografico.disenoGrafico.porcentajeIndesign;
    if (valorIndesign === '0' || valorIndesign === '') {

      document.querySelector('#InDesign').parentElement.parentElement.style.display = 'none';
    }
    // ocultar imgdetalle2
    const valorImgdetalle2 = this.disenografico.disenoGrafico.imagenDetalle2;
    if (valorImgdetalle2 === '') {

      document.querySelector('#imgdetalle2').parentElement.parentElement.style.display = 'none';
    }

    // ocultar imgdetalle3
    const valorImgdetalle3 = this.disenografico.disenoGrafico.imagenDetalle3;
    if (valorImgdetalle3 === '') {

      document.querySelector('#imgdetalle3').parentElement.parentElement.style.display = 'none';
    }

    // ocultar imgdetalle4
    const valorImgdetalle4 = this.disenografico.disenoGrafico.imagenDetalle4;
    if (valorImgdetalle4 === '') {

      document.querySelector('#imgdetalle4').parentElement.parentElement.style.display = 'none';
    }
  }

}
